"use client";

import Image from "next/image";
import Link from "next/link";

import { useTranslation } from "@/app/i18n/client";
import BadgeMenu from "@/components/global/Badge/BadeMenu";
import { homeConfig } from "@/config/home";
import pushGAHomePage from "@/libs/ga4/action/homePage";
import { useHotelStore } from "@/libs/store/HotelStore/useHotelStore";
import { convertToSnakeCase } from "@/utils/common/convertHelper/convertToSnakeCase";

const HomeSearchMobileComponent = ({
  lang,
  newMenu,
}: {
  lang: string;
  newMenu: any[];
}) => {
  const disableMenu = homeConfig.mobile;
  const { t } = useTranslation("home");
  const { setOpenPopupComingSoon } = useHotelStore();
  const handleClickMenu = (key: string) => {
    pushGAHomePage()?.ClickMenuOnSerchSection(key);
  };

  return (
    <div className="mt-[-55px]_ relative z-10 w-full px-4">
      <div className="bottom-[3.4rem]_ grid min-h-[6.938rem] grid-cols-3 rounded-lg bg-white p-2 shadow-md">
        {newMenu.map((item, index) => {
          const itemConfig = disableMenu.items.find(
            (configItem) => configItem.key === item.key,
          );
          if (!itemConfig) return null;

          const isComingSoon = itemConfig.comingSoon;
          const { showBadge } = itemConfig;
          const setId = convertToSnakeCase(`home-menu-${item.label}`);
          return (
            <Link
              id={setId}
              onClick={() => {
                handleClickMenu(item.key);
                if (!isComingSoon) return;
                setOpenPopupComingSoon(true);
              }}
              href={isComingSoon ? "#" : item.path}
              className="relative flex cursor-pointer flex-col items-center gap-y-1 rounded-2xl p-2 hover:bg-[#B82020] [&>div]:hover:!text-white"
              key={`home-menu-${index}`}
              title={t(`${item.label}`)}
            >
              <div className="flex size-12 items-center justify-center rounded-[500%] bg-background-baigeBG p-1">
                <span className="relative inline-block">
                  <Image
                    priority
                    width={0}
                    height={0}
                    sizes="100vw"
                    style={{ width: "100%", height: "auto" }}
                    alt={`${item.alt} Search Icon`}
                    src={item.icon}
                  />
                </span>
              </div>
              <div className="grid gap-y-[2px]">
                <div className="whitespace-nowrap text-center text-[14px] font-normal">
                  <span>{t(`${item.label}`)}</span>
                </div>
                {showBadge.enable && (
                  <div className="inline-flex justify-center">
                    <BadgeMenu label={t(`${showBadge.label}`)} />
                  </div>
                )}
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default HomeSearchMobileComponent;
